var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H25.9934C33.7254 0 39.9934 6.26801 39.9934 14V25.9934C39.9934 33.7254 33.7254 39.9934 25.9934 39.9934H14C6.26801 39.9934 0 33.7254 0 25.9934V14Z",
    fill: "#FAF5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3311 26.2457V13.7477C13.3311 13.1953 13.5505 12.6655 13.9411 12.2748C14.3318 11.8842 14.8616 11.6647 15.414 11.6647H25.829C26.05 11.6647 26.2619 11.7525 26.4182 11.9088C26.5744 12.065 26.6622 12.277 26.6622 12.4979V27.4955C26.6622 27.7164 26.5744 27.9284 26.4182 28.0846C26.2619 28.2409 26.05 28.3287 25.829 28.3287H15.414C14.8616 28.3287 14.3318 28.1092 13.9411 27.7186C13.5505 27.3279 13.3311 26.7981 13.3311 26.2457ZM13.3311 26.2457C13.3311 25.6932 13.5505 25.1634 13.9411 24.7728C14.3318 24.3821 14.8616 24.1627 15.414 24.1627H26.6622",
    stroke: "#9810FA",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white",
    transform: "translate(9.99829 9.99835)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManual);
export default __webpack_public_path__ + "static/media/user_manual.a9e90a34ba01d43fdc438274cd18a8aa.svg";
export { ForwardRef as ReactComponent };